require('jquery-form/jquery.form.js');

var autoAjax = require('./autoAjax.js').default;

module.exports = autoAjax;